/** @file Id prefix of every entity kind (`bone` → `bone_`, `image` → `img_`), used when minting ids. */
import type { EntityKind, IdPrefix } from '@pose2d/format/types';

/** Entity kind → the prefix its ids carry (`ids.re(prefix)` checks client-supplied ids). */
export const KIND_PREFIX: Readonly<Record<EntityKind, IdPrefix>> = {
  image: 'img',
  bone: 'bone',
  slot: 'slot',
  attachment: 'att',
  skin: 'skin',
  ik: 'ik',
  event: 'evt',
  socket: 'sock',
  animation: 'anim',
  reference: 'ref',
};
